import { render, staticRenderFns } from "./VisionFormBox.vue?vue&type=template&id=56c6b6df&"
import script from "./VisionFormBox.vue?vue&type=script&lang=js&"
export * from "./VisionFormBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports